import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./public/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./public/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./public/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./private/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'myrequests',
    loadChildren: () => import('./private/myrequests/myrequests.module').then( m => m.MyrequestsPageModule)
  },
  {
    path: 'myoffers',
    loadChildren: () => import('./private/myoffers/myoffers.module').then( m => m.MyoffersPageModule)
  },
  {
    path: 'add-offer',
    loadChildren: () => import('./private/add-offer/add-offer.module').then( m => m.AddOfferPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./private/notification/notification.module').then( m => m.NotificationPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
